export default {
  addNewAddress: 'افزودن آدرس جدید',
  selectedPointAddress: 'آدرس نقطه انتخابی',
  pleaseSelectAddressCoordinates: 'لطفا موقعیت مکانی آدرس را انتخاب کنید',
  changeCoordinates: 'تغییر موقعیت آدرس',
  editAddress: 'ویرایش آدرس',
  selectAddress: 'انتخاب آدرس',
  select_fromMyAddresses_html: 'انتخاب {title} از آدرس های من',
  select_fromPoiAddresses_html: 'انتخاب {title} از آدرس های سراسری',
  noAddressSelected: 'آدرسی انتخاب نشده!'
}
